import { forwardRef, type ReactNode } from "react";

type MobileNavTabInfo = {
  label: string;
  icon: ReactNode;
};

export type LandingSectionData = {
  id: string;
  content: ReactNode;
  mobileNavTab?: MobileNavTabInfo;
};

export const LandingPageSection = forwardRef<HTMLDivElement, LandingSectionData>(
  ({ id, content }, ref) => (
    <section id={id} ref={ref} className="relative isolate overflow-hidden">
      {content}
    </section>
  ),
);

LandingPageSection.displayName = "LandingSection";
